import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ImporterImage from '../../../../UI/ImporterImage/ImporterImage';
import Bouton from '../../../../UI/Bouton/Bouton';
import AttenteRequete from '../../../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import * as glossaire_pattern from '../../../../../ressources/glossaires/glossaire_pattern';
import * as glossaire_type_de_couche from '../../../../../ressources/glossaires/glossaire_type_de_couche';
import MessageErreur, {
  classeChampEnErreur,
} from '../../../../UI/MessageErreur/MessageErreur';
import { schemaNouvelleCouche } from '../../../../../services/schemas/coucheVue';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../../../../services/schemas/validerFormulaire';
import * as requestType from '../../../../../ressources/glossaires/glossaire_requetes';
import * as actions from '../../../../../services/actions';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import styles from '../../FormulaireVue/FormulaireVue.module.scss';

// Bornes de l'image au format 1920 x 1080, proposées en un clic.
const BORNES_1920_X_1080 = '[[0,0],[1080,1920]]';

const AjouterCouche = ({ view_id, affichageProfil }) => {
  const dispatch = useDispatch();
  const [layerType, setLayerType] = useState(glossaire_type_de_couche.Image);
  const [projectionId, setProjectionId] = useState(0);
  const [position, setPosition] = useState(0);
  const [layerName, setLayerName] = useState('');
  const [imageBase64, setImageBase64] = useState('');
  const [boundsImage, setBoundsImage] = useState('[[0,0],[0,0]]');
  const [geojsonContent, setGeojsonContent] = useState('');
  const [tilesUrl, setTilesUrl] = useState('');
  const [erreurs, setErreurs] = useState({});
  const [qgisWms, setQgisWms] = useState({
    url: '',
    parametre: {
      map: '',
      layers: '',
      format: '',
      transparent: '',
    },
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const setters = {
      layer_type: setLayerType,
      projection_id: setProjectionId,
      position: setPosition,
      layer_name: setLayerName,
      tiles_url: setTilesUrl,
      geojson_content: setGeojsonContent,
      bounds_image: setBoundsImage,
    };
    if (setters[name]) {
      setters[name](value);
    }
  };

  const handleQgisWmsChange = (event) => {
    const { name, value } = event.target;
    setQgisWms((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleQgisWmsParameterChange = (event) => {
    const { name, value } = event.target;
    setQgisWms((prev) => ({
      ...prev,
      parametre: {
        ...prev.parametre,
        [name]: value,
      },
    }));
  };

  const handleImageImport = (imageImporter) => {
    setImageBase64(imageImporter.base64);
  };

  const handleSubmit = () => {
    // Les nombres et les bornes partent tels que saisis : c'est le schéma qui
    // les convertit, et qui refuse une saisie illisible là où parseInt
    // donnait NaN et IsArrayString remplaçait les bornes en silence.
    let formulaireCouche = {
      layer_type: layerType,
      projection_id: projectionId,
      position: position,
      layer_name: layerName,
    };

    switch (parseInt(layerType)) {
      case glossaire_type_de_couche.Image:
        formulaireCouche = {
          ...formulaireCouche,
          image_base64: imageBase64,
          bounds_image: boundsImage,
          geojson_content: '',
          tiles_url: '',
        };
        break;
      case glossaire_type_de_couche.Tuile:
        formulaireCouche = {
          ...formulaireCouche,
          tiles_url: tilesUrl,
          image_base64: '',
          bounds_image: '',
          geojson_content: '',
        };
        break;
      case glossaire_type_de_couche.GeoJSON:
        formulaireCouche = {
          ...formulaireCouche,
          geojson_content: geojsonContent,
          image_base64: '',
          bounds_image: '',
          tiles_url: '',
        };
        break;
      case glossaire_type_de_couche.QgisWms:
        formulaireCouche = {
          ...formulaireCouche,
          qgis_wms: qgisWms,
          geojson_content: '',
          image_base64: '',
          bounds_image: '',
          tiles_url: '',
        };
        break;
      default:
        formulaireCouche = null;
        break;
    }

    if (!formulaireCouche) {
      console.warn('Type de couche inconnu');
      return;
    }

    const { valide, donnees, erreurs } = validerFormulaire(
      schemaNouvelleCouche,
      formulaireCouche
    );
    setErreurs(erreurs);
    if (!valide) {
      return;
    }
    dispatch(actions.reqAjouterCoucheVue(view_id, donnees));
  };

  const classeChamp = (champ) =>
    [
      s.form_control,
      messageDuChamp(erreurs, champ) ? classeChampEnErreur : '',
    ].join(' ');

  // Valeurs affichées par les champs texte. Ils étaient non contrôlés : un
  // champ vide à l'écran pouvait donc cacher la valeur réellement envoyée,
  // comme les bornes [[0,0],[0,0]] ou la position 0.
  const valeursDesChamps = {
    projection_id: projectionId,
    position: position,
    layer_name: layerName,
    tiles_url: tilesUrl,
    geojson_content: geojsonContent,
    bounds_image: boundsImage,
  };

  const renderFormInput = (name, label, pattern) => (
    <div className={[s.col_11, styles.styleNexw].join(' ')}>
      <span className={[styles.stil2].join(' ')}>{label}</span>
      <input
        type="text"
        pattern={pattern}
        className={classeChamp(name)}
        placeholder={name}
        name={name}
        value={valeursDesChamps[name] ?? ''}
        disabled={affichageProfil}
        onChange={handleInputChange}
      />
      <MessageErreur cle={messageDuChamp(erreurs, name)} />
    </div>
  );

  // Seule l'URL est exigée : le schéma range son erreur sous qgis_wms.
  const renderQgisWmsInput = (name, label, pattern, handler) => {
    const valeur = name === 'url' ? qgisWms.url : qgisWms.parametre[name];
    const cleErreur =
      name === 'url' ? messageDuChamp(erreurs, 'qgis_wms') : null;
    return (
      <div className={[s.col_11, styles.styleNexw].join(' ')}>
        <span className={[styles.stil2].join(' ')}>{label}</span>
        <input
          type="text"
          pattern={pattern}
          className={[
            s.form_control,
            cleErreur ? classeChampEnErreur : '',
          ].join(' ')}
          placeholder={name}
          name={name}
          value={valeur ?? ''}
          disabled={affichageProfil}
          onChange={handler}
        />
        <MessageErreur cle={cleErreur} />
      </div>
    );
  };

  let formulaireCouche;
  switch (parseInt(layerType)) {
    case glossaire_type_de_couche.Image:
      formulaireCouche = (
        <>
          <ImporterImage
            extensionAccepter={'image/png, image/jpeg, image/jpg, .svg'}
            gererImageImporter={handleImageImport}
          />
          <MessageErreur cle={messageDuChamp(erreurs, 'image_base64')} />
          <div className={[styles.stillers, s.card].join(' ')}>
            <div className={[styles.stillersT, s.card_header].join(' ')}>
              {checkMot('bounds_image')}
            </div>
            <div className={s.card_body}>
              {/* Les deux boutons radio partagent un même groupe et suivent la
                  valeur des bornes : auparavant, une fois le format
                  1920 x 1080 choisi, on ne pouvait plus revenir aux bornes
                  personnalisées. */}
              <div>
                <input
                  type="radio"
                  name="choix_bounds_image"
                  checked={boundsImage !== BORNES_1920_X_1080}
                  onChange={() => setBoundsImage('[[0,0],[0,0]]')}
                  disabled={affichageProfil}
                />
                {checkMot("Limites de l'image personalise ")}

                <div
                  style={{
                    display:
                      boundsImage !== BORNES_1920_X_1080 ? 'block' : 'none',
                  }}
                >
                  {' '}
                  {renderFormInput(
                    'bounds_image',
                    checkMot('bounds_image'),
                    glossaire_pattern.array
                  )}
                </div>
              </div>

              <div>
                <input
                  type="radio"
                  name="choix_bounds_image"
                  checked={boundsImage === BORNES_1920_X_1080}
                  onChange={() => setBoundsImage(BORNES_1920_X_1080)}
                  disabled={affichageProfil}
                />
                {checkMot('1920 x 1080')}
              </div>
            </div>
          </div>
        </>
      );
      break;
    case glossaire_type_de_couche.Tuile:
      formulaireCouche = (
        <>
          {renderFormInput(
            'tiles_url',
            checkMot('tiles_url'),
            glossaire_pattern.text
          )}
        </>
      );
      break;
    case glossaire_type_de_couche.GeoJSON:
      formulaireCouche = (
        <>
          {renderFormInput(
            'geojson_content',
            checkMot('geojson_content'),
            glossaire_pattern.text
          )}
        </>
      );
      break;
    case glossaire_type_de_couche.QgisWms:
      formulaireCouche = (
        <>
          {renderQgisWmsInput(
            'url',
            checkMot('url'),
            glossaire_pattern.text,
            handleQgisWmsChange
          )}
          {renderQgisWmsInput(
            'map',
            checkMot('map'),
            glossaire_pattern.text,
            handleQgisWmsParameterChange
          )}
          {renderQgisWmsInput(
            'layers',
            checkMot('layers'),
            glossaire_pattern.text,
            handleQgisWmsParameterChange
          )}
          {renderQgisWmsInput(
            'format',
            checkMot('format'),
            glossaire_pattern.text,
            handleQgisWmsParameterChange
          )}
          {renderQgisWmsInput(
            'transparent',
            checkMot('transparent'),
            glossaire_pattern.text,
            handleQgisWmsParameterChange
          )}
        </>
      );
      break;
    default:
      formulaireCouche = 'type de couche invalide';
      break;
  }

  return (
    <>
      <div className={[s.row, styles.marge].join(' ')}>
        <div className={[s.col_11, styles.styleNexw].join(' ')}>
          <label className={[styles.stil2].join(' ')}>
            {checkMot('layer_type')}
          </label>
          <select
            value={layerType}
            onChange={handleInputChange}
            name="layer_type"
            className={[s.form_control, s.mb_2].join(' ')}
          >
            <option value={glossaire_type_de_couche.Image}>
              {checkMot('image')}
            </option>
            <option value={glossaire_type_de_couche.Tuile}>
              {checkMot('tuile')}
            </option>
            <option value={glossaire_type_de_couche.GeoJSON}>
              {checkMot('geojson')}
            </option>
            <option value={glossaire_type_de_couche.QgisWms}>
              {checkMot('qgis_wms')}
            </option>
          </select>
        </div>
        {renderFormInput(
          'projection_id',
          checkMot('projection_id'),
          glossaire_pattern.integer
        )}
        {renderFormInput(
          'position',
          checkMot('position'),
          glossaire_pattern.integer
        )}
        {renderFormInput(
          'layer_name',
          checkMot('layer_name'),
          glossaire_pattern.text
        )}
        {formulaireCouche}
      </div>
      <div className={[s.text_left, styles.styleNexw].join(' ')}>
        <AttenteRequete
          request_type={requestType.ajouter_une_couche_de_vue}
          str={checkMot('creation_en_cour')}
        >
          <Bouton cliquer={handleSubmit}>{checkMot('enregistrer')}</Bouton>
        </AttenteRequete>
      </div>
    </>
  );
};

export default AjouterCouche;
